import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "title-container" }
const _hoisted_3 = { class: "content-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ReglePastille = _resolveComponent("ReglePastille")!
  const _component_StepOne = _resolveComponent("StepOne")!
  const _component_StepTwo = _resolveComponent("StepTwo")!
  const _component_BottomNavigation = _resolveComponent("BottomNavigation")!
  const _component_WaitingModal = _resolveComponent("WaitingModal")!
  const _component_SuccessModal = _resolveComponent("SuccessModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("span", null, _toDisplayString(_ctx.$t('reclamation.do.title')), 1),
        _createVNode(_component_ReglePastille, { cle: "reclamation.definition" }),
        _createVNode(_component_ReglePastille, { cle: "reclamation.etapesObligatoires" })
      ]),
      _createElementVNode("div", _hoisted_3, [
        (this.step === 1)
          ? (_openBlock(), _createBlock(_component_StepOne, {
              key: 0,
              selectedSite: this.selectedSite,
              title: _ctx.$t('siteSelection.searchBar.title.request.intervention'),
              onSelectSite: this.selectSite
            }, null, 8, ["selectedSite", "title", "onSelectSite"]))
          : _createCommentVNode("", true),
        (this.step === 2)
          ? (_openBlock(), _createBlock(_component_StepTwo, {
              key: 1,
              selectedSite: this.selectedSite,
              onDescription: _ctx.handleDescriptionChange
            }, null, 8, ["selectedSite", "onDescription"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_BottomNavigation, {
      back: _ctx.back,
      cancel: _ctx.cancel,
      confirm: _ctx.request,
      confirmButtonDisabled: !_ctx.isValid(),
      first: _ctx.step === 1,
      last: _ctx.step === 2,
      next: _ctx.next
    }, null, 8, ["back", "cancel", "confirm", "confirmButtonDisabled", "first", "last", "next"]),
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_WaitingModal, {
          key: 0,
          text: _ctx.$t('intervention.request.pending')
        }, null, 8, ["text"]))
      : _createCommentVNode("", true),
    (_ctx.success)
      ? (_openBlock(), _createBlock(_component_SuccessModal, {
          key: 1,
          subtitle: _ctx.$t('intervention.success.subtitle'),
          title: _ctx.response,
          onCancel: _ctx.exit
        }, null, 8, ["subtitle", "title", "onCancel"]))
      : _createCommentVNode("", true)
  ], 64))
}